import ModalComponent from "./ModalComponent.js";

(function(){
    new ModalComponent({
        toggle : "data-toggle-modal",
    });
}());
